module.exports = __webpack_public_path__ + "img/thumbnail_DallSheep_f_normal.5e921f70.png";